import { ModalNextProvider } from '@jutro/components';
import _ from 'lodash';
import { log } from '@jutro/logger';
import { PromptService } from './PromptService';
import { handleAction } from './actionHelper';
export const routeConfirmationModal = (promptName, promptCallback) => {
  const promptProps = PromptService.popPrompt(promptName);
  if (!promptProps) {
    promptCallback(true);
    return;
  }
  const title = promptProps.title,
    message = promptProps.message;
  if (!title || !message) {
    handleTriggerEvent(promptProps, promptCallback);
  } else {
    const icon = 'mi-warning';
    const status = 'warning';
    const answer = ModalNextProvider.showConfirm({
      title,
      message,
      status,
      icon
    });
    answer.then(action => {
      if (action === 'cancel') {
        promptCallback(false);
      } else {
        handleTriggerEvent(promptProps, promptCallback);
      }
    }, () => {
      promptCallback(false);
    });
  }
};
async function handleTriggerEvent(promptProps, promptCallback) {
  const trigger = promptProps.trigger,
    instance = promptProps.instance;
  if (trigger && _.isFunction(trigger)) {
    const triggerAnswer = trigger();
    if (_.isObject(triggerAnswer)) {
      try {
        await handleAction(triggerAnswer, instance);
        promptCallback(instance.props.history.location === instance.props.location);
      } catch (e) {
        log.error(e);
        promptCallback(false);
      }
    } else if (_.isBoolean(triggerAnswer)) {
      promptCallback(triggerAnswer);
    } else {
      promptCallback(true);
    }
  } else {
    promptCallback(true);
  }
}